import axios from "axios";
import { store } from "../redux/store";

const BASE_URL = process.env.REACT_APP_API_URL;
console.log(BASE_URL);
const axiosClient = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

const axiosClientAuth = axios.create({
  baseURL: BASE_URL,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

axiosClientAuth.interceptors.request.use((config) => {
  const state = store.getState();
  const token = state.auth?.token;
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

axiosClientAuth.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      const path = window.location.pathname;
      // Avoid a reload loop: if we are already on an auth page, do not
      // redirect/clear again (a failed login attempt already returns 401).
      if (path !== "/login" && path !== "/register") {
        window.localStorage.clear();
        window.location.replace("/login");
      }
    }
    return Promise.reject(error);
  }
);

export { axiosClient, axiosClientAuth };
